import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "../../components/layout/Sidebar";
import ApplicationList from "../../components/applications/ApplicationList/ApplicationList";
import { useAuth } from "../../context/AuthContext";
import CardHeader from "../../components/common/CardHeader";

function Applications() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const { checkPermission } = useAuth();

  const appMode = useMemo(
    () =>
      checkPermission("Zmiana przypisania sprawy")
        ? "coordinator"
        : checkPermission("Obsługa wniosków")
        ? "operator"
        : checkPermission("Obsługa wysyłki")
        ? "shipping"
        : "user",
    [checkPermission]
  );

  const handleResize = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarVisible(true);
    } else {
      setIsSidebarVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <CardHeader
        text={
          "Moje wnioski " +
          (checkPermission("Zmiana przypisania sprawy")
            ? "(Koordynator)"
            : checkPermission("Obsługa wniosków")
            ? "(Operator)"
            : "")
        }
        onlyText="true"
      />
      <ApplicationList
        mode={appMode}
        paymentMode={false}
        shippingMode={false}
      />
    </>
  );
}

export default Applications;
